import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Navigate, Route, Routes, useParams} from 'react-router-dom';

import {getCriteria, selectSearchCriteria} from 'src/components/criteria-strip/services/criteria-strip-slice';
import {SEARCH_RESULT_TABS} from 'src/constants';
import {PageNotFound} from 'src/modules/error-page';

import {AccountSearchResult} from './account-search-result';
import {UserSearchResult} from './user-search-result';

export const AdvancedSearchResult = () => {
    const dispatch = useDispatch();
    const queryParams = useParams<{searchId: string}>();
    const searchId = queryParams?.searchId || '';
    const searchCriteria = useSelector(selectSearchCriteria);

    useEffect(() => {
        if (!searchCriteria) {
            dispatch(getCriteria(searchId));
        }
    }, [searchId, searchCriteria, dispatch]);

    if (!searchCriteria) {
        return <PageNotFound/>;
    }

    return (
        <Routes>
            <Route path={`/${SEARCH_RESULT_TABS.ACCOUNTS}`} element={<AccountSearchResult searchId={searchId}/>}/>
            <Route path={`/${SEARCH_RESULT_TABS.USERS}`} element={<UserSearchResult searchId={searchId}/>}/>

            <Route
                path="*"
                element={<Navigate replace={true} to={`/search-result/${searchId}/${SEARCH_RESULT_TABS.ACCOUNTS}`}/>}
            />
        </Routes>
    );
};
